module.exports = __webpack_public_path__ + "static/img/avatar.1e6db733.png";